import { render, staticRenderFns } from "./SubTopNav.vue?vue&type=template&id=cc22351e&scoped=true&"
import script from "./SubTopNav.vue?vue&type=script&lang=js&"
export * from "./SubTopNav.vue?vue&type=script&lang=js&"
import style0 from "./SubTopNav.vue?vue&type=style&index=0&id=cc22351e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc22351e",
  null
  
)

export default component.exports